/** ID DOM seguro para tooltips del sidebar (evita () y otros chars inválidos en querySelector). */
export function sidebarNavDomId(activeUrl?: string, label?: string): string {
  const seed = (activeUrl || label || "item").replace(/^\//, "");
  const slug = seed.replace(/[^a-zA-Z0-9_-]+/g, "-").replace(/^-+|-+$/g, "");
  return `sidebar-nav-${slug || "item"}`;
}
